import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import SupplierList from "@/components/lists/supplier.vue"
  import SupplierToolbar from "@/components/toolbars/supplier.vue"
  import {nextTick, onBeforeMount, PropType, ref} from "vue"
  import {
    Supplier,
    SupplierInput,
    SupplierResponse
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Paginator from "@/components/paginator.vue"
  import {Supplier as SupplierClient} from "@/endpoints/rutsolve/gql/resolvers/supplier"
  import {SupplierSelector as Storage} from "@/storage/supplier_selector"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'supplier',
  props: {
    "value": {
    default: null,
    required: false,
    type: Object as PropType<Supplier>
  },
    "valueModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels([
    "select",
  ], ["update:value"]),
  setup(__props, { emit: __emit }) {

  const value = _useModel(__props, "value")

  const emits = __emit

  const error = ref<Error>(null)
  const supplierClient = new SupplierClient()
  const supplierResponse = ref<SupplierResponse>(null)
  const supplierInput = ref<SupplierInput>(null)
  const selectedIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  function update() {
    Storage.writeSupplierInput(supplierInput.value)
    read()
  }

  async function select() {
    const selectedSupplier = supplierResponse.value.records[selectedIndex.value]
    value.value = selectedSupplier
    Storage.writeSelectedSupplierID(selectedSupplier.id)
    await nextTick()
    emits("select")
  }

  function reset() {
    Storage.deleteSupplierInput()
    Storage.deleteSelectedSupplierID()
    selectedIndex.value = null
    value.value = null
    read()
  }

  async function read() {
    try {
      const storedSupplierInput = Storage.readSupplierInput()
      supplierInput.value = structuredClone(storedSupplierInput)
      supplierResponse.value = await supplierClient.selector(storedSupplierInput)
      if (!supplierResponse.value || !supplierResponse.value.records) {
        return
      }
      const storedSelectedSupplierID = Storage.readSelectedSupplierID()
      for (const [index, supplier] of supplierResponse.value.records.entries()) {
        if (supplier.id == storedSelectedSupplierID) {
          selectedIndex.value = index
          value.value = supplier
          break
        }
      }
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(SupplierToolbar, {
        value: supplierInput.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((supplierInput).value = $event)),
        onUpdate: _cache[1] || (_cache[1] = ($event: any) => (update())),
        onReset: _cache[2] || (_cache[2] = ($event: any) => (reset()))
      }, null, 8, ["value"]),
      (supplierResponse.value)
        ? (_openBlock(), _createBlock(SupplierList, {
            key: 0,
            selectedIndex: selectedIndex.value,
            "onUpdate:selectedIndex": _cache[3] || (_cache[3] = ($event: any) => ((selectedIndex).value = $event)),
            items: supplierResponse.value.records,
            onSelect: _cache[4] || (_cache[4] = ($event: any) => (select()))
          }, null, 8, ["selectedIndex", "items"]))
        : _createCommentVNode("", true),
      (supplierResponse.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 1,
            currentPage: supplierInput.value.plot.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((supplierInput.value.plot.page) = $event)),
            itemTotal: supplierResponse.value.recordsTotal,
            pageItems: supplierInput.value.plot.items,
            onUpdate: _cache[6] || (_cache[6] = ($event: any) => (update()))
          }, null, 8, ["currentPage", "itemTotal", "pageItems"]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 2,
            error: error.value,
            "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})